import '@xcel-next/rendering/src/assets/brands/lecker/main.scss'
import { createClientApp } from '../../shared/ssr/entry-client'
import { createApp } from './main'

createClientApp(createApp)
